import Superagent from 'superagent'
import Storage from './storage.service'

const { HOST_API } = _CONSTANTS_

export default {
    getCharges,
    getChargesShipment,
    downloadCharges,
    uploadCharges,
    deleteCharge,
    createCharge
}

function getCharges(query = {}) {
    return new Promise((resolve, reject) => {
        Superagent
           .get(`${HOST_API}/charges`)
           .set('access', Storage.getItem('access'))
           .query(query)
           .end((err, res) => {
               resolve(res.body)
           })
    })
}

function getChargesShipment(shipmentId) {
    return new Promise((resolve, reject) => {
        Superagent
           .get(`${HOST_API}/charges/shipment/${shipmentId}`)
           .set('access', Storage.getItem('access'))
           .end((err, res) => {
               resolve(res.body)
           })
    })
}

function downloadCharges(query) {
    return new Promise((resolve, reject) => {
        Superagent
           .post(`${HOST_API}/charges/download`)
           .set('access', Storage.getItem('access'))
           .responseType('blob')
           .query({admin: true})
           .send({...query, timezone: new Date().getTimezoneOffset()/60})
           .end((err, res) => {
               resolve(res.body)
           })
    })
}

function uploadCharges(data) {
    return new Promise((resolve, reject) => {
        Superagent
           .post(`${HOST_API}/charges/upload`)
           .set('access', Storage.getItem('access'))
           .attach('chargesFile', data.chargesFile)
           .end((err, res) => {
               resolve(res.body)
           })
    })
}

function deleteCharge(chargeId) {
    return new Promise((resolve, reject) => {
        Superagent
           .delete(`${HOST_API}/charges/${chargeId}`)
           .set('access', Storage.getItem('access'))
           .end((err, res) => {
               resolve(res.body)
           })
    })
}

function createCharge(data) {
    return new Promise((resolve, reject) => {
        Superagent
           .post(`${HOST_API}/charges`)
           .set('access', Storage.getItem('access'))
           .send(data)
           .end((err, res) => {
               resolve(res.body)
           })
    })
}